export const gradosEstudio = [
  {Id: 'C', Nombre: "UNIVERSIDAD"},
  {Id: 'G', Nombre: "POSTGRADO (MAESTRIA O DOCTORADO)"},
  {Id: 'H', Nombre: "PREPARATORIA"},
  {Id: 'O', Nombre: "OTRO"},
  {Id: 'S', Nombre: "PASANTE"},
  {Id: 'T', Nombre: "CARRERA COMERCIAL"},
]
